<template lang="pug">
  .wrap.static
    form(@submit.prevent="apply")
      .main
        .main-inner
          .panel-title
            h2
              img(:src="siteLogoBlue()" :alt="siteName()")
            h3 パスワード再設定
          .panel(v-if="applied")
            p.message
              | パスワード再設定用の<br />メールを送信しました
          .panel(v-else)
            p
              span.panel-label
                | メールアドレス
              input(type="email" v-model="email" placeholder="foo@example.com", :disabled="locked")
            ErrorMessage(:errors="errors" name="system")
            p.buttons
              input.button-main.button-block(type="submit",
                                value="パスワード再設定用メールを送信", :disabled="disabled")
          p.panel-note
            router-link(:to="{ name: 'SignIn' }") ログイン画面に戻る
    footer.footer
      p.copyright
        | &copy; {{ copyright() }}
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ErrorMessage from './parts/ErrorMessage'

  export default {
    components: { ErrorMessage },
    async asyncData ({ store }) {
      store.commit('user/preparePasswordResetApplication')
    },
    data () {
      return {
        email: '',
        applied: false,
      }
    },
    computed: {
      ...mapState({
        errors: state => state.user.passwordErrors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
      }),
      disabled () {
        return this.locked || !this.email
      },
    },
    methods: {
      async apply () {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/applyPasswordReset', { email: this.email })
          this.applied = true
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue